import { makeStyles } from "@material-ui/core/styles"
import Button from "@mui/material/Button"
import "./bottombar.css"
import { useLocation } from "react-router"
import { useState, useEffect } from "react"
import zIndex from "@material-ui/core/styles/zIndex"

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "#fff",
    width: "100%",
    height: "84px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }
}))

const button: any = {
  height: "52px",
  borderRadius: "4px",
  color: "#fff",
  fontWeight: "bold",
  letterSpacing: "0.4px",
  fontFamily: "Lato",
  fontSize: "16px",
  lineHeight: "24px",
  textTransform: "none",
  backgroundColor: "#0E65E5",
  ":disabled": {
    backgroundColor: "#6EA2EF",
    color: "#fff"
  }
}

export default function ButtonBottomBar(props: any) {
  const classes = useStyles()
  const [addClass, setAddclass] = useState("footerBar")
  const location = useLocation()

  useEffect(() => {
    if (
      location.pathname === "/edocs" ||
      location.pathname === "/visitsummary"
    ) {
      if (props.buttonPosition === "fixed") {
        setAddclass("footerBar")
      } else {
        setAddclass("footerBar footerBarEdocs")
      }
    }
    // eslint-disable-next-line
  }, [location])

  return (
    <>
      <div
        className={`${classes.root}  ${addClass}`}
        style={{
          display: props.buttonDisplay === true ? "none" : "flex",
          zIndex: props.zIndex?.length !== 0 ? props.zIndex : "unset"
        }}
      >
        <Button
          style={{
            width:
              location.pathname === "/edocs" && props.buttonPosition !== "fixed"
                ? "100%"
                : "",
            boxShadow:
              props.buttonPosition === "fixed"
                ? "0 -1px 4px 0 rgb(0 0 0 / 12%)"
                : "none"
          }}
          className={`button ${props.className}`}
          sx={{ ...button }}
          variant="contained"
          disabled={props.disabled}
          size="large"
          onClick={props.onClick}
          endIcon={props.endIcon}
          startIcon={props.startIcon}
        >
          {props.text}
        </Button>
      </div>
    </>
  )
}
